document.addEventListener('invalid', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  const panel = event.target.closest('[data-cc-product-panel]');
  const dialog = panel?.querySelector('dialog');
  if (!dialog || dialog.open || typeof panel.showDialog !== 'function') return;
  event.preventDefault();
  panel.showDialog();
  requestAnimationFrame(() => {
    event.target.focus();
    event.target.reportValidity();
  });
}, true);

document.addEventListener('shopify:block:select', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  const panel = event.target.closest('[data-cc-product-panel]')
    || event.target.querySelector('[data-cc-product-panel]');
  if (typeof panel?.showDialog === 'function') panel.showDialog();
});

for (const eventName of ['dialog:open', 'dialog:close']) {
  document.addEventListener(eventName, (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('[data-cc-product-panel]')) return;
    event.target.querySelector('[data-cc-panel-trigger]')?.setAttribute('aria-expanded', String(eventName === 'dialog:open'));
  }, true);
}

function updatePersonalization(event) {
  if (!(event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement)) return;
  const summary = event.target.closest('[data-cc-product-panel]')?.querySelector('[data-cc-panel-summary]');
  if (!summary) return;
  const value = event.target.type === 'checkbox' ? (event.target.checked ? event.target.value : '') : event.target.value.trim();
  summary.textContent = value;
  summary.hidden = !value;
}

document.addEventListener('input', updatePersonalization);
document.addEventListener('change', updatePersonalization);


document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const trigger = event.target.closest('[data-cc-description-trigger]');
  if (!trigger) return;
  const product = trigger.closest('.product-information');
  const panel = product?.querySelector('[data-cc-panel-source="description"]');
  if (typeof panel?.showDialog !== 'function') return;
  event.preventDefault();
  panel.showDialog();
});
